import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";


@Component({
   selector: 'app-pvendita',
   templateUrl: './pvendita.component.html',
   styleUrls: ['./pvendita.component.scss']
})
export class PvenditaComponent implements OnInit, AfterViewInit {
   public pVenditaId;
   public static pVenditaId;

   constructor( private route: ActivatedRoute,
                private router: Router) {

      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
         this.pVenditaId = this.route.snapshot.paramMap.get('pvendita_id')
         PvenditaComponent.pVenditaId = this.route.snapshot.paramMap.get('pvendita_id')
      });
   }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
   }

   _getPVenditaId(){
      return this.pVenditaId
   }

   static _getPVenditaId(){
      return PvenditaComponent.pVenditaId
   }

}
